import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import {
  fetchAddCallback,
  IAddCallbackRequest,
  IAddCallbackResponse200,
  IAddCallbackResponse400,
} from '../../../shared/repositories/newbuilding-calltracking/v1/add-callback';

export type TRequestCallbackParams = Omit<IAddCallbackRequest, 'clientType'>;

export async function requestCallback(parameters: TRequestCallbackParams) {
  try {
    const httpApi = getHttpApi();

    const { response } = await fetchAddCallback<IAddCallbackResponse200, IAddCallbackResponse400>({
      httpApi,
      parameters: {
        ...parameters,
        clientType: 'callbackOrderForm',
      },
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']],
        },
      },
    });

    return response;
  } catch (error) {
    const logger = getLogger();

    logger.error(error, {
      domain: 'browser.services.requestCallback()',
    });

    throw error;
  }
}
